import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, materialize, dematerialize } from 'rxjs/operators';
import { Role } from '../_models/oauth.models';

@Injectable()
export class LoginInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        const roles: string[] = ['ejecutor','supervisor','prevencion','auditoria','administrador'];

        return of(null).pipe(mergeMap(() => {
            if (request.url.endsWith('/users/authenticate') && request.method === 'POST') {
                const rol = roles.find(x => x === request.body.rol);
                if (!rol) {
                    return error('Usuario o contraseña incorrecto');
                } else {
                    let roleUser:string;

                    switch(rol) {
                        case 'ejecutor':
                            roleUser = Role.Ejecutor;
                            break;
                        case 'supervisor':
                            roleUser = Role.Supervisor;
                            break;
                        case 'prevencion':
                            roleUser = Role.Prevencion;
                            break;
                        case 'auditoria':
                            roleUser = Role.Auditoria;
                            break;
                        case 'administrador':
                            roleUser = Role.Administrador;
                            break;
                    }

                    return ok({
                        id: 1,
                        username: request.body.username,
                        firstName: "eglobal",
                        lastName: "eglobal",
                        role: roleUser,                    
                        token: "ROLE_" + request.body.rol,
                        idEsquema: request.body.esquema_id,
                        esquema: request.body.esquema_dsc
                    });
                }
                
            }
            console.log( "request: " + request);
            console.log( "url invocada: " + request.url);
            // pass through any requests not handled above
            return next.handle(request);
        }))
        // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
        .pipe(materialize())
        .pipe(delay(1000))
        .pipe(dematerialize());

        // private helper functions

        function ok(body) {
            console.log("--> ok ");
            return of(new HttpResponse({ status: 200, body }));
        }

        function unauthorised() {
            console.log("--> unauthorised ");
            return throwError({ status: 401, error: { message: 'Unauthorised' } });
        }

        function error(message) {
            console.log("--> error ");
            return throwError({ status: 400, error: { message } });
        }
    }
}

export let LoginProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: LoginInterceptor,
    multi: true
};